<mat-card class="example-card">
     <mat-card-header class="titreFrm ">
      <mat-card-title>{{titre}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
        <div *ngIf="exist;else attente"></div>
        <ng-template #attente>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>
        <mat-card>
            <div class="displayFlex">
                <div>
                    <mat-form-field     appearance="outline"  class="width-125">
                        <mat-label>Année</mat-label>
                        <mat-select name="selectedAnnee" [(ngModel)]="selectedAnnee" >
                            <mat-option *ngFor="let annee of listeAnnee" [value]="annee">
                                {{annee}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field     appearance="outline"  class="width-125">
                        <mat-label>Mois</mat-label>
                        <mat-select name="selectedMois" [(ngModel)]="selectedMois" >
                            <mat-option *ngFor="let mois of monthsTab;let i = index" [value]="i">
                                {{mois}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <app-recherche 
                        #collaborateurComponent
                        *ngIf="fenetre == '2' || fenetre == '3'" 
                        [style]="{'width' : '200px'}"
                        [api]="generalService.api" 
                        [numColonneToShow]="1" 
                        [numColonneToReturn]="0" 
                        recherche="avtAcollaborateur" 
                        [param]="'0'" 
                        name="name_2" 
                        placeholder="Manageur" >
                    </app-recherche>
                </div>
                <div>
                    <button (click)="getListeFiles()" [disabled]="!exist" mat-raised-button class="colorGreen"><mat-icon>search</mat-icon>Filtrer</button>
                    <button (click)="selectFile()" [disabled]="!exist" mat-raised-button class="colorGreen"><mat-icon>cloud_upload</mat-icon>Impoter</button>
                    <button (click)="telechargerFile()" [disabled]="!exist" mat-raised-button class="colorBlue"><mat-icon>cloud_download</mat-icon>Télécharger</button>
                    <!-- <button [disabled]="!exist" mat-raised-button class="colorRed"><mat-icon>cached</mat-icon>Remplacer</button> -->
                    <button (click)="supprimerFile()" [disabled]="!exist" mat-raised-button class="colorRed"><mat-icon>save</mat-icon>Supprimer</button>
                </div>
            </div>
            <div class="content-conge">
                <app-liste #listeFicheConmponent [titre]="" [usePhoneTemplate]="true" [dataSource]="listeDocument" [columns]="columns"></app-liste>
                
            </div>
        </mat-card>
    </mat-card-content> 
</mat-card>
<input type="file" style="display: none;" id="file" (change)="onChangefile($event)">